<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="visible" class="modal-mask">
        <div class="modal-box">
          <img :src="DialogTop" class="dialog-top" alt="" />
          <div class="modal-container">
            <img :src="DialogIc" class="dialog-ic" alt="" />
            <div class="modal-body" :class="{ mb40: !showFooter }">
              <!-- <div class="title">{{ title }}</div> -->
              <div>{{ content }}</div>
              <slot></slot>
            </div>
            <div class="modal-footer" v-if="showFooter">
              <slot name="footer">
                <!-- <button @click="handleCancel">{{ cancelText }}</button> -->
                <button class="btn" @click="onConfirm"></button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
  import DialogTop from '/@/assets/images/dialog/dialog-top.png';
  import DialogIc from '/@/assets/images/dialog/dialog-ic.png';

  import { ref, watch, onUnmounted } from 'vue';
  import { useDialogStoreWithOut } from '/@/store/modules/dialog';
  const props = defineProps<{
    title?: {
      type: String;
      default: '';
    };
    content?: string;
    onConfirm: () => void;
    onCancel: () => void;
    showFooter?: boolean;
  }>();

  const visible = ref(true);
  const dialogStore = useDialogStoreWithOut();
  console.log('dialogStore...', dialogStore);
  watch(
    () => dialogStore.isOpen,
    (newVal) => {
      visible.value = newVal;
    },
  );
  function onConfirm() {
    props.onConfirm();
    visible.value = false;
  }

  function onCancel() {
    props.onCancel();
    dialogStore.closeDialog();
    visible.value = false;
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9997;
  }
  .modal-box {
    width: 68%;
    z-index: 9998;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -20vh;
  }
  .modal-container {
    width: 100%;
    background: white;
    border-radius: 23px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    padding: 0 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
    margin-top: -0.8px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .modal-body {
    /* padding: 20px; */
    /* max-height: 70vh; */
    min-height: 60px;
    overflow-y: auto;
    font-size: 16px;
    color: #333333;
    line-height: 26px;
    word-break: break-all;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  .dialog-top {
    width: 21.3%;
    /* height: 15px; */
    margin: 0;
    z-index: 9999;
    object-fit: cover;
  }

  .dialog-ic {
    width: 65px;
    height: 65px;
    margin-top: -5px;
    animation: shake 0.8s ease;
  }
  @keyframes shake {
    0% {
      transform: scale(1) rotate(0deg);
    }
    25% {
      transform: scale(1.1) rotate(2deg);
    }
    50% {
      transform: scale(0.9) rotate(-2deg);
    }
    75% {
      transform: scale(1.05) rotate(1deg);
    }
    100% {
      transform: scale(1) rotate(0deg);
    }
  }
  .btn {
    width: 143px;
    height: 50px;
    margin-top: 10px;
    background-image: url('/@/assets/images/dialog/dialog-btn.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .title {
    font-size: 15px;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .mb40 {
    padding-bottom: 10px;
    box-sizing: border-box;
  }
</style>
